import React from "react";
import { Box, Divider } from "@mui/material";
import { LocalShippingOutlined } from "@mui/icons-material";

import ResultItem from "./ResultItem";
import { localizeDateTimeShort } from "utils/dateFormats";

const ShipmentResult = ({ shipments = [] }) => {
  return (
    <Box>
      <div className="mb-2 px-5 font-semibold">shipment</div>

      {shipments.map((ship, index) => (
        <a
          href={`/app/crm/shipment/${ship?._id}/detail`}
          key={ship?._id}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <ResultItem
            title={`${ship?.shipmentId}`}
            subtitle={localizeDateTimeShort(ship.createdAt)}
            icon={() => <LocalShippingOutlined color="primary" />}
          />
          {index !== shipments.length - 1 && <Divider />}
        </a>
      ))}
    </Box>
  );
};

export default ShipmentResult;
